import { ActionTypes as a } from "./dynamicFilters.types.js";
const E = (p, t) => p.reduce((e, r) => (e[r.property] = t?.[r.property] ?? /* @__PURE__ */ new Map(), e), {}), l = (p, t) => {
  switch (t.type) {
    case a.RESET:
      return E(t.payload);
    case a.UPDATE_SELECTABLE_CARD: {
      const e = {
        ...p
      }, {
        property: r,
        value: s,
        checked: c,
        exclusiveValues: n
      } = t.payload;
      return e[r] && ((n.includes(s) || n.some((o) => e[r].has(o))) && (e[r] = /* @__PURE__ */ new Map()), e[r].set(s, c)), {
        ...e
      };
    }
    case a.UPDATE_SELECTABLE_RADIO_CARD:
    case a.UPDATE_RADIO: {
      const e = {
        ...p
      }, {
        property: r,
        value: s,
        checked: c
      } = t.payload;
      return e[r] && (e[r] = /* @__PURE__ */ new Map()), e[r].set(s, c), {
        ...e
      };
    }
    case a.RESET_FILTER: {
      const {
        property: e
      } = t.payload;
      return {
        ...p,
        [e]: /* @__PURE__ */ new Map()
      };
    }
    case a.UPDATE_FILTERS:
      return {
        ...t.payload
      };
    default:
      return p;
  }
};
export {
  E as createFreshInitialState,
  l as filtersReducer
};
